<!-- 添加按钮 -->
<template>
  <div :class="{'disabled': disabled}">
    <div v-if="!file_url" class="img-select-box" :style="selectBoxCss" @click="modal_file_input">
      <slot v-if="$slots.default"></slot>
      <template v-else>+</template>
    </div>
    <div v-else class="img-show"  @click="modal_file_input">
      <img :src="file_url">
    </div>
    <input :style="{display:'none'}" type="file" ref="inputFile" @change="onFileSelected"/>
  </div>
</template>
<script>
export default {
  name: "image-select",
  props: {
    selectBoxCss:{
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    path:{
      type: String,
      default: "",
    },
    file_type: {
      type: Array,
      default: () => {
        return []
      }
    },
    file_size_mb:{
      type:Number,
      default: 0,
    }
  },
  data(){
    return {
      file_url:this.path,
    }
  },
  watch:{
    path(newPath){
      if(newPath !== this.file_url){
        this.file_url = newPath;
      }
      if(!newPath){
        this.$refs.inputFile.value = "";
      }
    }
  },
  methods:{
    //点击上传文件
    modal_file_input(){
      if(this.disabled){
        return
      }
      this.$refs.inputFile.click()
    },
    onFileSelected ({ target, dataTransfer }) {
      const files = target.files || dataTransfer.files;
      this.getFileName(files, target);
    },
    getFileName (files, target) {
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }

      // if (files.length > 1) {
      //   return this.getMultipleName(files)
      // }

      if (files.length === 1) {
        if(this.file_type.length > 0){
          let validExtensions = this.file_type.map(i => i.toLowerCase())
          let fileExtension = files[0].name.split(".").pop().toLowerCase();
          if(!validExtensions.includes(fileExtension)){
            this.$errorMsg(this.$I18n("file_type_check") + " : " +validExtensions.join(" / "))
            return
          }
        }
        if(this.file_size_mb > 0 && parseInt(files[0].size/(1024*1024) ) > this.file_size_mb ){
          this.$errorMsg(this.$I18n("file_too_big") + " " + this.file_size_mb + "MB")
          return
        }
        this.$api.uploadFile_PUT({
          file : files[0], 
          // zone : this.UserInfo.srv_zone,
          zone : "CN",
        })
          .then(this.$Then(res => {
            this.file_url = res.data.get_url
            this.$emit('updatePath', res.data.get_url, files[0].name)
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      }
      return null
    },
  },
  computed:{
  },
};
</script>

<style lang="scss" scoped>
  div{
    user-select: none;
  }
  .disabled, .disabled>div{
    cursor: no-drop !important;
  }
  .img-select-box{
    width :95px;
    height:95px;
    border:1px #BBBBBB solid;
    border-radius: 2px;
    font-size: 36px;
    font-weight:400;
    color: #BBBBBB;
    line-height: 93px;
    text-align:center;
    cursor: pointer;
  }
  .img-show, .img-show img{
    box-sizing: border-box; 
    max-height: 120px;
    max-width : 200px;
    width: auto;
    height: auto;
  }
  .img-show img{
    border: 1px solid #CCCCCC;
  }
</style>